__turbopack_context__.v({
  "bullets": "_649ADG_bullets",
  "container": "_649ADG_container",
  "content": "_649ADG_content",
  "icon": "_649ADG_icon",
});
